module.exports = __webpack_public_path__ + "media/images/purchase-step-1-23da0ce13a21a865eb6e673a189e2b8b.png";